module.exports = __webpack_public_path__ + "img/plus-box.f1810cee.svg";